import dynamic from 'next/dynamic';
import Seo from '../components/common/Seo';
import DefaultHeader from '../components/header/header-rslhome';
import DefaultFooter from '../components/footer/footer-3';

const HelpCenter = () => {
    return (
        <>
            <Seo pageTitle="Help Center | Royalsmartlimousine - Lifestyle | RSL I UAE  " />

            <div className="header-margin"></div>
            <img
          src="/img/pages/about/help.png"
          alt="image"
          className="rounded-4"
        />
            <section className="layout-pt-md">
                <div className="container">
                    <div className="">

                        <h1 className="text-20 fw-600">Help</h1>
                        <p
                            className="text-dark-1"

                        >
                            If you need help, you can contact RSL customer support anytime by sending us an email:
                        </p>
                        <br></br>
                        <h1 className="text-20 fw-600">Desktop and mobile web</h1>
                        <p
                            className="text-dark-1"

                        >
                            Click on the circular Gear settings button in the bottom left-hand corner.
                            Then tap on Help.
                            <br />
                        </p>
                        <br></br>
                        <h1 className="text-20 fw-600">iOS and Android app</h1>
                        <p
                            className="text-dark-1"

                        >
                            Tap on your circular Gear settings button in the top right-hand corner.
                            Then tap on Help.
                            <br />
                        </p>
                        <br></br>
                    </div>
                </div>
            </section>


            <DefaultFooter />
            {/* End Call To Actions Section */}
        </>
    );
};

export default dynamic(() => Promise.resolve(HelpCenter), { ssr: false });
